"use client";

/**
 * NewForm DS animated icon — a text document. The page outline draws on,
 * then the text lines draw in one after another. Brand purple by default.
 * See ./shared for the animation/colour conventions.
 */

import { motion } from "motion/react";
import {
  type AnimatedIconProps,
  drawProps,
  IconSvg,
  useReduce,
} from "./shared";

export function DocumentIcon({ size, className }: AnimatedIconProps) {
  const reduce = useReduce();
  return (
    <IconSvg size={size} className={className}>
      <motion.path
        d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"
        {...drawProps(reduce, 0)}
      />
      <motion.path d="M14 2v5h5" {...drawProps(reduce, 0.18)} />
      <motion.path d="M8 13h8" {...drawProps(reduce, 0.36)} />
      <motion.path d="M8 17h8" {...drawProps(reduce, 0.5)} />
      <motion.path d="M8 9h3" {...drawProps(reduce, 0.64)} />
    </IconSvg>
  );
}
